import React, { useEffect, useRef } from 'react';
import BackgroundMap from '../../components/BackgroundMap/BackgroundMap';

import { LocalitaFeature } from '../../services/api';
import { MapLocationSet } from '../../types/mapTypes';

interface HomeProps {
  isLoggedIn?: boolean;
  isQrSession?: boolean;
  openMenu?: () => void;
  mapFeatures?: LocalitaFeature[] | null;
  mapBounds?: MapLocationSet['bounds'] | null;
  onLocalitaAction?: (action: 'apri' | 'chiudi', feature: LocalitaFeature) => void;
  onMapReady?: (map: any) => void;
}

// TODO: Spostare getColorByVolNum in un file utils condiviso
// const getColorByVolNum = (d: number, opacity: number = 1): string => {
//   if (d > 6) {
//     return `rgba(71, 67, 67, ${opacity})`; // #474343b5
//   }
//   
//   switch (d) {
//     case 6: // Rappresenta 6+
//       return `rgba(71, 67, 67, ${opacity})`; // #474343b5
//     case 5:
//       return `rgba(157, 76, 235, ${opacity})`; // #9d4ceb
//     case 4:
//       return `rgba(235, 42, 42, ${opacity})`; // #eb2a2a
//     case 3:
//       return `rgba(253, 154, 4, ${opacity})`; // #fd9a04
//     case 2:
//       return `rgba(97, 243, 5, ${opacity})`; // #61f305
//     case 1:
//       return `rgba(0, 231, 255, ${opacity})`; // #00e7ff
//     default:
//       return `rgba(153, 153, 153, ${opacity})`; // grigio per 0 volontari o valori non gestiti
//   }
// };

const Home: React.FC<HomeProps> = ({ isLoggedIn, isQrSession, openMenu, mapFeatures, mapBounds, onLocalitaAction, onMapReady }) => {
  const mapRef = useRef<any>(null);
  const previousLoginState = useRef(isLoggedIn);

  // Effetto zoom e apertura menu quando si effettua il login
  useEffect(() => {
    if (!previousLoginState.current && isLoggedIn && mapRef.current) {
      // Login appena effettuato - facciamo uno zoom animato e apriamo il menu
      console.log('Login effettuato - zoom animato sulla mappa e apertura menu');

      // Le sessioni QR hanno già un'uscita precaricata (nessun fetch) — il flyToBounds verso
      // quell'uscita (App.tsx -> BackgroundMap) parte quasi subito. Questo zoom generico a
      // livello 7, pensato per il login normale (dove a 300ms non c'è ancora nulla di selezionato),
      // interromperebbe a metà quel volo più specifico. Saltalo per le sessioni QR.
      if (!isQrSession) {
        // Usa direttamente l'API di Leaflet per lo zoom animato
        setTimeout(() => {
          mapRef.current.setZoom(7, { animate: true, duration: 1 });
        }, 300);
      }

      // Apri il menu dopo un breve delay per dare tempo allo zoom
      setTimeout(() => {
        if (openMenu) {
          openMenu();
        }
      }, 800);
    }
    previousLoginState.current = isLoggedIn;
  }, [isLoggedIn, openMenu, isQrSession]);

  const handleMapReady = (map: any) => {
    mapRef.current = map;
    if (onMapReady) onMapReady(map);
  };

  if (isLoggedIn) {
    return (
      <div className="page-container home-logged-in-container">
        <BackgroundMap
          center={[42.9450, 13.8833]}
          zoom={6}
          showControls={true}
          pageId="home-logged-in"
          onMapReady={handleMapReady}
          features={mapFeatures || undefined}
          boundsToFit={mapBounds || undefined}
          onLocalitaAction={onLocalitaAction}
        />
      </div>
    );
  }

  return (
    <div className="page-container home-login-container">
      <BackgroundMap
        center={[42.9450, 13.8833]}
        zoom={6}
        showControls={true}
        pageId="home-login"
      />
    </div>
  );
};

export default Home; 